// Copyright (c) 2018 Deere & Company

import * as busyCounter from './busy-counter';
import {deleteFile as deleteFileRepo, getFiles as getFileRepo} from '../../product/shared/repositories';
import actions from '../actions-list';
import {readLatestPerUnitMeasurements} from '../../shared/action-creators/latest-per-unit-measurements';
import {saveAddedAmountOfUse} from '../repositories';
import {successAlertBar} from '../services/alert-bar';
import {translate} from '../services/translation-service';
import {updateAmountOfUseHistory} from '../../product/details/action-creators/amount-of-use-history';
import {updateEditAmountOfUseModalVisibility} from '../../product/details/action-creators/amount-of-use-modal-visibility';

export const updateUnitMeasurements = (field, data) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            dispatch({
                data,
                field,
                type: actions.UPDATE_LATEST_EDITED_PER_UNIT_MEASUREMENTS
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const resetAddAmountPerUnitMeasurements = () =>

    dispatch =>

        dispatch({
            type: actions.RESET_LATEST_PER_EDITED_UNIT_MEASUREMENTS
        });

export const addAmountOfUseRecord = (amountOfUse, pin) =>
            async dispatch => {

                dispatch(busyCounter.increaseBusyCounter());

                try {

                    await saveAddedAmountOfUse(amountOfUse, pin);

                    successAlertBar(translate('AMOUNT_OF_USE_CREATED_SUCCESSFULLY'));

                    readLatestPerUnitMeasurements(pin)(dispatch);
                    updateAmountOfUseHistory(pin)(dispatch);
                    updateEditAmountOfUseModalVisibility(false)(dispatch);

                } catch (error) {

                } finally {

                    dispatch(busyCounter.decreaseBusyCounter());

                }

            };

export const addFileForUpdateAmountOfUse = data => ({
    data,
    type: actions.UPDATE_LATEST_EDITED_ADD_FILE_PER_UNIT_MEASUREMENTS
});

export const updateAmountUnitInMeasurementReading = (property, value) =>

    dispatch =>

        dispatch({
            property,
            type: actions.UPDATE_ADD_AMOUNT_OF_USE_AMOUNT,
            value
        });

export const deleteFileAddAmountOfUse = fileToDelete =>
    async (dispatch, getState) => {

        const doesFileExist = getState().updateUnitMeasurements.file.some(item => item.fileName === fileToDelete.fileName && item.serialNumber === fileToDelete.serialNumber);

        if (doesFileExist) {

            dispatch(busyCounter.increaseBusyCounter());

            try {

                await deleteFileRepo(fileToDelete);

                const files = await getFileRepo(fileToDelete);

                dispatch({
                    files,
                    type: actions.UPDATE_LATEST_EDITED_DELETE_FILE_PER_UNIT_MEASUREMENTS
                });

            } catch (error) {

            } finally {

                dispatch(busyCounter.decreaseBusyCounter());

            }

        }

    };



// WEBPACK FOOTER //
// ./src/shared/action-creators/update-unit-measurements.js